import { createSharedComposable } from '@vueuse/core'

const _useDashboard = () => {
  const route = useRoute()
  const isNotificationsSlideoverOpen = ref(false)
  const notifications = ref<any[]>([])
  const hasNotifications = computed(() => notifications.value.some(notification => notification.status === 'inbox'))

  watch(() => route.fullPath, () => {
    isNotificationsSlideoverOpen.value = false
  })

  return {
    isNotificationsSlideoverOpen,
    notifications,
    hasNotifications,
  }
}

export const useDashboard = createSharedComposable(_useDashboard)
